import React from 'react';

// Toast Context
export const ToastContext = React.createContext();
